import type { IconSvgObject } from './types';

const GreaterThanIcon: IconSvgObject = [
  ["path", { d: "M7 4L15.3306 10.0405C17.5565 11.6545 17.5565 12.3455 15.3306 13.9595L7 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default GreaterThanIcon;
